// Drop-in shim that re-exports react-router-dom equivalents
// under the same names used by next/navigation in the original pages.
//
// Usage in pages: import { useRouter, useSearchParams, usePathname } from '@/lib/navigation'

export { useNavigate as _useNavigate, useLocation } from 'react-router-dom'

import { useNavigate, useLocation, useSearchParams as rrUseSearchParams } from 'react-router-dom'

// Next.js useSearchParams() returns URLSearchParams directly (not a tuple).
export function useSearchParams(): URLSearchParams {
  const [params] = rrUseSearchParams()
  return params
}

// Matches the next/navigation useRouter() surface used in Blyn pages:
//   router.push(href)   → navigate(href)
//   router.replace(href) → navigate(href, { replace: true })
//   router.back()        → navigate(-1)
export function useRouter() {
  const navigate = useNavigate()
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
  }
}

// Matches next/navigation usePathname()
export function usePathname(): string {
  return useLocation().pathname
}
